// extracted by mini-css-extract-plugin
export default {"swiper":"Carrusel_swiper__t3pD-","tarjetas":"Carrusel_tarjetas__WV6pD","datos":"Carrusel_datos__eNl1z","botonP":"Carrusel_botonP__Kl67t","botonN":"Carrusel_botonN__A6fYi"};